import { FaultRow } from './FaultRow';

type Row = Parameters<typeof FaultRow>[0]['row'];

export function FaultsList({
  rows,
  onAcknowledge,
  ackingId,
}: {
  rows: unknown[];
  // Optional: when provided, an Acknowledge button is rendered per fault.
  onAcknowledge?: ((id: string) => void) | undefined;
  ackingId?: string | null | undefined;
}) {
  if (rows.length === 0) return <div className="muted">No faults to show.</div>;
  return (
    <>
      {rows.map((r) => {
        const row = r as Row;
        return (
          <FaultRow
            key={row.id}
            row={row}
            onAcknowledge={onAcknowledge ? () => onAcknowledge(row.id) : undefined}
            acking={ackingId === row.id}
          />
        );
      })}
    </>
  );
}
